import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-serif mb-3">
            探索<strong>直播分类</strong>
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg mx-auto">
            八大热门直播分类，总有一款适合您的兴趣
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden hover:ring-2 hover:ring-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-32 md:h-40 overflow-hidden">
                <img
                  src={category.image}
                  alt={`${category.name}直播分类`}
                  title={`${category.name} - 直播互动体验平台`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="text-white font-semibold text-sm md:text-base">
                    {category.name}
                  </h3>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {category.description}
                </p>
                <div className="flex items-center gap-1 mt-2 text-xs text-foreground-400">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-user-line text-xs"></i>
                  </div>
                  <span>{category.count.toLocaleString()} 位主播</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}